module.exports = __webpack_public_path__ + "img/orange_126.04be0d79.png";